import React, { Fragment, useState, useImperativeHandle, useEffect } from 'react';
import { Row, Col } from "antd";
import clsx from 'clsx';
import customStyles from "../../../../../../assets/styles/customStyles";
import { NavLink } from "react-router-dom";
import NumberIcon from "../../../../../../assets/images/icon_actions/123Icon.svg";
import EnterIcon from "../../../../../../assets/images/icon_actions/EnterIcon.svg";



export const VirtualKeyboard = React.forwardRef((props, ref) => {
    const { onKeyPress, onKeyEnter, checkComponentPermission, roleManagement, idNamingConversion,
        handleSubmit, headerView, activeInputs, handlePrint, paymentProcess, form, handleNewSales, selected, handlePaymentProcess, returnProducts, loader } = props;
    const [keyBoardType, setKeyBoardType] = useState(true);
    const [capitalLetter, setCapitalLetter] = useState(true);
    const classes = customStyles();
    const keys = [
        ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
        ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
        ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'],
        ['ab', 'Z', 'X', 'C', 'V', 'B', 'N', 'M', 'Enter'],
        ['123', 'Space', ',', '@', '.'],
    ];

    const numberKeys = [
        ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
        ['123', 'Space', '.', 'Enter'],
    ];

    const handleClick = (key) => {
        if (key === 'Space') {
            onKeyPress(' ');
        } else if (key === 'Enter') {
            onKeyEnter(key);
        } else if (key === '123') {
            setKeyBoardType(!keyBoardType)
        } else if (key === 'ab') {
            setCapitalLetter(!capitalLetter);
        } else {
            onKeyPress(capitalLetter ? key : key.toLowerCase());
        }
    };

    useImperativeHandle(ref, () => ({
        keyBoardChange(v) {
            setKeyBoardType(v);
        }
    }));

    useEffect(() => {
        if (activeInputs) {
            if (activeInputs === 'quantity' ||
                activeInputs === 'amountReceived' ||
                activeInputs === 'customerMobile' ||
                activeInputs === 'discountAmount' ||
                activeInputs === 'roundOffAmount' ||
                activeInputs === 'amount') {
                setKeyBoardType(false);
            } else {
                setKeyBoardType(true);
            }
        }
    }, [activeInputs]);

    return (
        <Row className={clsx(classes.padding15t, classes.keyletters, { [classes.keywordnumber]: !keyBoardType }, { [classes.disabled]: headerView, })}>
            {
                keyBoardType ? <>
                    {keys.map((row, rowIndex) => (
                        <Col span={24} key={rowIndex}>
                            <Row>
                                {
                                    row.map((key) => (
                                        <Fragment key={key}>
                                            {
                                                key === 'A' && <Col className={clsx(classes.width5)}></Col>
                                            }
                                            <Col className={clsx(classes.width10, { [classes.width15]: key === '123' }, { [classes.width12]: key === 'ab' }, { [classes.width18]: key === 'Enter' }, { [classes.flexOne]: key === 'Space' })}>
                                                <div className={clsx(classes.keywordOuter)} onClick={() => handleClick(key)}>
                                                    <div className={clsx(classes.keywordInner, { [classes.keySpacebar]: key === 'Space' },
                                                        { [classes.keyfs15]: (key === 'ab' || key === 'Enter' || key === '123' || key === '@') })}>
                                                        {
                                                            (key === '123' || key === 'ab' || key === 'Enter') && <img src={(key === '123' || key === 'ab') ? NumberIcon : EnterIcon} alt={key} style={{ marginRight: 5 }} />
                                                        }
                                                        {key === 'Space' ? '' : key === 'Enter' ? key : key === 'ab' ? capitalLetter ? key : key.toUpperCase() : capitalLetter ? key : key.toLowerCase()}
                                                    </div>
                                                </div>
                                            </Col>
                                            {
                                                key === 'L' && <Col className={clsx(classes.width5)}></Col>
                                            }
                                        </Fragment>
                                    ))
                                }
                            </Row>
                        </Col>
                    ))}
                </> : <>
                    {numberKeys.map((row, rowIndex) => (
                        <Col span={24} key={rowIndex}>
                            <Row>
                                {
                                    row.map((key) => (
                                        <Col key={key} className={clsx({
                                            [classes.disabled]: key === '123' && (activeInputs === 'quantity' ||
                                                activeInputs === 'amountReceived' ||
                                                activeInputs === 'customerMobile' ||
                                                activeInputs === 'discountAmount' ||
                                                activeInputs === 'roundOffAmount')
                                        }, { [classes.width20]: key === 'Enter' || key === '1' || key === '2' || key === '3' || key === '4' || key === '5' || key === '6' || key === '7' || key === '8' || key === '9' || key === '0' },
                                            { [classes.width10]: key === '123' || key === ',' || key === '.' }, { [classes.width15]: key === '123' || key === ',' || key === '.' }, { [classes.width50]: key === 'Space' }, { [classes.flexOne]: key === 'Space' })}>
                                            <div className={clsx(classes.keywordOuter)} onClick={() => handleClick(key)}>
                                                <div className={clsx(classes.keywordInner, { [classes.keywordInnerDirection]: key === '123' }, { [classes.keywordnum]: (key !== 'ab' && key !== ',' && key !== '.' && key !== 'Enter' && key !== 'Space' && key !== '123') }, { [classes.keySpacebar]: key === 'Space' },
                                                    { [classes.flexcol]: key === '123' }, { [classes.keyfs15]: (key === 'ab' || key === 'Enter' || key === '123') })}>
                                                    {
                                                        (key === '123' || key === 'ab' || key === 'Enter') && <img src={(key === '123' || key === 'ab') ? NumberIcon : EnterIcon} alt={key} style={{ marginRight: 5 }} />
                                                    }
                                                    {key === 'Space' ? '' : key === '123' ? <div><div className={{ [classes.disabled]: activeInputs === 'quantity' }}>{key}</div><div>ABC</div></div> : key}

                                                </div>
                                            </div>
                                        </Col>
                                    ))
                                }
                            </Row>
                        </Col>
                    ))}
                </>
            }

            <Col className={clsx(classes.width20)}>
                {
                    roleManagement !== '' && checkComponentPermission('Store Sales', 'Page', 'New Sales') &&
                    <NavLink to={'#'}
                        id={idNamingConversion('New Sales Key', 'storeSales', 'Button')}
                        onClick={() => handleNewSales()} className={clsx(classes.keywordOuter)}>
                        <div className={clsx(classes.keywordInner, classes.flexcol, classes.keyfs15)}>
                            {form?.salesType === 'Sale' ? 'New Sales' : 'New Sales Return'}<span>(Alt + N)</span></div></NavLink>
                }
            </Col>
            <Col className={clsx(classes.width20)}>
                <NavLink to={'#'}
                    id={idNamingConversion('Save Key', 'storeSales', 'Button')}
                    onClick={() => {
                        if (paymentProcess) {
                            handleSubmit('CREATED', paymentProcess);
                        } else {
                            handleSubmit('CREATED')
                        }
                    }} className={clsx(classes.keywordOuter,
                        { [classes.disabled]: headerView || selected?.length === 0 || (form?.isReturnWithReceipt && returnProducts?.length === 0) },
                        { [classes.loadingA]: loader })}>
                    <div className={clsx(classes.keywordInner, classes.flexcol, classes.keyfs15)}>{form?.id ? 'Update' : 'Save'}<span>(Alt + S)</span></div>
                </NavLink>
            </Col>
            <Col className={clsx(classes.width20)}>
                <NavLink to={'#'}
                    id={idNamingConversion('Print Key', 'storeSales', 'Button')}
                    onClick={() => handlePrint(true)} className={clsx(classes.keywordOuter,
                        { [classes.disabled]: selected?.length === 0 },
                        { [classes.loadingA]: loader })}>
                    <div className={clsx(classes.keywordInner, classes.flexcol, classes.keyfs15)}>Print<span>(Alt + P)</span></div>
                </NavLink>
            </Col>
            <Col className={clsx(classes.width40)}>
                {
                    paymentProcess ? <>
                        {
                            roleManagement !== '' && checkComponentPermission('Store Sales', 'Page', 'Confirm') &&
                            <NavLink to={'#'}
                                id={idNamingConversion('Confirm Key', 'storeSales', 'Button')}
                                onClick={() => handleSubmit('CONFIRMED', paymentProcess)}
                                className={clsx(classes.keywordOuter, { [classes.disabled]: (selected?.length === 0 || (!form?.amountReceived && form?.salesType === 'Sale') || (form?.isReturnWithReceipt && returnProducts?.length === 0)) }, { [classes.loadingA]: loader })}>
                                <div className={clsx(classes.keywordInner, classes.flexcol, classes.keyfs15)}>{form?.salesType === 'Sale Return' ? 'Refund' : 'Confirm'}<span>(Alt + O)</span></div>
                            </NavLink>
                        }
                    </> : <>
                        {
                            roleManagement !== '' && checkComponentPermission('Store Sales', 'Page', 'Process Payment') &&
                            <NavLink to={'#'}
                                id={idNamingConversion('Process Payment Key', 'storeSales', 'Button')}
                                onClick={() => handlePaymentProcess(true)}
                                className={clsx(classes.keywordOuter, { [classes.disabled]: paymentProcess || selected?.length === 0 || (form?.isReturnWithReceipt && returnProducts?.length === 0) }, { [classes.loadingA]: loader })}>
                                <div className={clsx(classes.keywordInner, classes.flexcol, classes.keyfs15)}>Process Payment<span>(Alt + P)</span></div>
                            </NavLink>
                        }
                    </>
                }
            </Col>
        </Row >
    )
})